import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectPlacesListOptions,
  setListOptions,
  selectPlacesListStructure,
} from '@/features/domain/lists'
import { useEditingStateWithCtx } from '@/atoms'
import { useAppDispatch } from '@/store'

export function useSorter() {
  const listOptions = useSelector(selectPlacesListOptions)
  const listStructure = useSelector(selectPlacesListStructure)
  const { editing } = useEditingStateWithCtx('place')
  const dispatch = useAppDispatch()

  const [direction, setDirection] = useState(() => listOptions.sort[0].direction)

  useEffect(() => {
    if (!listOptions.sort) return
    if (listOptions.sort[0].direction === direction) return

    dispatch(
      setListOptions({
        category: 'places',
        options: {
          ...listOptions,
          sort: [
            { ...listOptions.sort[0], direction },
            {
              field: 'type',
              direction,
            },
          ],
        },
      }),
    )
  }, [dispatch, direction, listOptions])

  return { editing, direction, setDirection, noEntries: listStructure.totalItems === 0 }
}
